import React, { useEffect } from 'react';
import { SeoBar } from '../components/SeoBar';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { HeroSection } from './spinner-ultra-precision-turning/HeroSection';
import { SpecsSection } from './spinner-ultra-precision-turning/SpecsSection';
import { MachineModelsSection } from './spinner-ultra-precision-turning/MachineModelsSection';
export function SpinnerUltraPrecisionTurningPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="min-h-screen w-full bg-white flex flex-col" data-id="element-4011">
      <SeoBar data-id="element-4012" />
      <Header data-id="element-4013" />
      <main className="flex-grow" data-id="element-4014">
        <div className="w-full bg-white pb-20" data-id="element-4015">
          <HeroSection data-id="element-4016" />
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-id="element-4017">
            <SpecsSection data-id="element-4018" />
            <MachineModelsSection data-id="element-4019" />
          </div>
        </div>
      </main>
      <Footer data-id="element-4020" />
    </div>;
}